<template>
    <div :id="divId">
        <h5>{{ $t("DOCUMENTS.title") }}</h5>

        <!-- Popup para Adicionar E-mails -->
        <div v-if="showEmailPopup" class="popup-overlay">
            <div class="popup-content">
                <button type="button" @click="addEmailRow" class="btn-icon-add">
                    <div class="icon-plus">+</div>
                </button>

                <h5>{{ $t("DOCUMENTS.signatoriesTitle") }}</h5>
                <div v-show="errorMessage && signatories.length > 0"
                     class="medium mb-2 text-danger text-right bold">
                    {{errorMessage}}
                </div>

                <div v-if="signatories.length > 0" class="form-check mb-2 mt-3">
                    <input type="checkbox"
                           v-model="workflow"
                           @change="workflow = workflow ? 1 : 0"
                    class="form-check-input"
                    id="selectAllSignatories">
                    <label class="form-check-label" for="selectAllSignatories">{{ $t("REGISTERSIGNERS.workflow") }}</label>
                </div>

                <ul class="list-group">
                    <li v-for="(signatory, index) in signatories" :key="index"
                        class="list-group-item d-flex justify-content-between align-items-center"
                        draggable="true"
                        @dragstart="dragStart(index)"
                        @dragover.prevent
                        @drop="drop(index)"
                        @dragend="dragEnd">

                        <div class="form-group mr-2 w-50">
                            <label>Email</label>
                            <input type="email" v-model="signatories[index].email"
                                   :class="{'is-invalid': signatory.hasError}" class="form-control mr-2"
                                   placeholder="Email" @blur="isValidEmail(index)" />
                        </div>

                        <div class="form-group mr-2 w-25">
                            <label>{{ $t("REGISTERSIGNERS.signatureTypeLabel") }}</label>
                            <select v-model="signatories[index].act" class="form-control mr-2">
                                <option value="1">{{ $t("REGISTERSIGNERS.signatureType.option1") }}</option>
                                <option value="2">{{ $t("REGISTERSIGNERS.signatureType.option2") }}</option>
                                <option value="3">{{ $t("REGISTERSIGNERS.signatureType.option3") }}</option>
                                <option value="4">{{ $t("REGISTERSIGNERS.signatureType.option4") }}</option>
                                <option value="5">{{ $t("REGISTERSIGNERS.signatureType.option5") }}</option>
                                <option value="6">{{ $t("REGISTERSIGNERS.signatureType.option6") }}</option>
                                <option value="7">{{ $t("REGISTERSIGNERS.signatureType.option7") }}</option>
                                <option value="8">{{ $t("REGISTERSIGNERS.signatureType.option8") }}</option>
                                <option value="9">{{ $t("REGISTERSIGNERS.signatureType.option9") }}</option>
                                <option value="10">{{ $t("REGISTERSIGNERS.signatureType.option10") }}</option>
                                <option value="11">{{ $t("REGISTERSIGNERS.signatureType.option11") }}</option>
                                <option value="12">{{ $t("REGISTERSIGNERS.signatureType.option12") }}</option>
                                <option value="13">{{ $t("REGISTERSIGNERS.signatureType.option13") }}</option>
                            </select>
                        </div>

                        <div class="form-group mr-2 w-40">
                            <label>{{ $t("REGISTERSIGNERS.signatureCertificate") }}</label>
                            <select v-model="signatories[index].certificadoicpbr" class="form-control mr-2">
                                <option value="1">{{ $t("REGISTERSIGNERS.useCertificateYes") }}</option>
                                <option value="0">{{ $t("REGISTERSIGNERS.useCertificateNo") }}</option>
                            </select>
                        </div>

                        <div class="form-group mr-2 w-50">
                            <label>{{ $t("REGISTERSIGNERS.signatureDocSelfie") }}</label>
                            <select v-model="signatories[index].docSelfie" class="form-control mr-2">
                                <option value="0">{{ $t("REGISTERSIGNERS.requestDocSelfieDefault") }}</option>
                                <option value="1">{{ $t("REGISTERSIGNERS.requestDocument") }}</option>
                                <option value="2">{{ $t("REGISTERSIGNERS.requestSelfie") }}</option>
                            </select>
                        </div>

                        <button type="button" @click="removeEmail(index)" class="btn-icon-trash pt-3">
                            <div class="icon-trash"></div>
                        </button>

                    </li>
                </ul>

                <div class="text-right mt-3">
                    <button type="button" class="btn btn-secondary btn-mobile mr-3" @click="cancelEmail">{{ $t("REGISTERSIGNERS.cancel") }}</button>
                    <button v-if="signatories.length > 0" type="button" class="btn btn-primary" @click="saveEmails">{{ $t("REGISTERSIGNERS.save") }}</button>
                </div>
            </div>
        </div>

        <button type="button"
                v-if="updatedEnvelopeUid"
                class="btn btn-link btn-sm float-right button-update"
                v-on:click="updateEnvelopeView">
            {{ $t("DOCUMENTS.buttonUpdate") }}
        </button>
        <div class="box spaced padded">
            <div v-show="load.isLoading" style="text-align: center !important">
                <div class="spinner spinner-md"></div>
                <div>
                    <span class="bold">{{ load.msg }}</span>
                </div>
            </div>
            <div v-show="!load.isLoading">
                <div>
                    <div v-if="updatedEnvelopeUid">
                        <div class="alert alert-light-info bold padded">
                            <span v-if="error.isError">{{ error.msg }}</span>
                            <span v-else>
                                {{
                            $t("DOCUMENTS.envelopeNotSent")
                                }}
                            </span>
                        </div>
                        <div class="padded mb-2 mr-lg-1 btn-mobile text-right">
                            <button type="button"
                                    class="btn btn-primary btn-mobile"
                                    v-on:click="getInterfaceUrl">
                                {{ $t("DOCUMENTS.viewEnvelope") }}
                            </button>
                        </div>
                    </div>
                    <div v-else class="box spaced padded">
                        <div v-if="error.isError">
                            <h5 class="alert alert-light-warning bold">
                                {{ error.msg }}
                            </h5>
                        </div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table table-hover table-bpm-module">
                                    <thead>
                                        <tr>
                                            <th>
                                                {{ $t("DOCUMENTS.colunmSelect") }}
                                            </th>
                                            <th>
                                                {{ $t("DOCUMENTS.colunmName") }}
                                            </th>
                                            <th>
                                                {{ $t("DOCUMENTS.colunmUser") }}
                                            </th>
                                            <th>
                                                {{ $t("DOCUMENTS.colunmLocation") }}
                                            </th>
                                            <th>
                                                {{ $t("DOCUMENTS.colunmDate") }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="form-group">
                                        <tr class="p-2 m-2"
                                            v-for="document in documents"
                                            :key="document.id">
                                            <td>
                                                <div class=" custom-control custom-checkbox">
                                                    <input type="checkbox"
                                                           class="custom-control-input"
                                                           v-model="document.checked"
                                                           :id="document.id"
                                                           @change="
                                                        updateSelectedDocumentsList()
                                                    " />
                                                    <label class="custom-control-label"
                                                           :for="document.id"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <a :href="document.previewPath"
                                                   class="
                                                    bold
                                                    no-horizontal-scroll
                                                "
                                                   target="_blank">{{ document.name }}</a>
                                            </td>
                                            <td>
                                                <h5 class="bold m-0">
                                                    {{ document.user }}
                                                </h5>
                                            </td>
                                            <td>
                                                <h5 class="bold m-0">
                                                    {{ document.origin }}
                                                </h5>
                                            </td>
                                            <td>
                                                <h5 class="bold m-0">
                                                    {{ document.date }}
                                                </h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="mb-2 mr-lg-1 btn-mobile text-right">
                                <button type="button"
                                        class="btn btn-primary mr-3"
                                        @click="showEmailPopup = true"
                                        v-if="signPlatformUid === platformUids.D4Sign">
                                    {{ $t("REGISTERSIGNERS.add") }}
                                </button>
                                <button type="button"
                                        class="btn btn-tertiary btn-mobile"
                                        v-on:click="sendDocuments"
                                        v-if="!isRequestSignatureDisabled">
                                    {{ $t("DOCUMENTS.requestSignature") }}
                                </button>
                            </div>
                            <div v-show="isNoDocumentsWarningVisible"
                                 class="medium mb-2 text-danger text-right bold">
                                {{
                                $t("DOCUMENTS.validations.noDocumentsSelected")
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import SharedMixin from "../mixins/SharedMethods.js";
    import EventBus from "./../EventBus.js";
    import PlatformUids from "../shared/platformUids.js";

    export default {
        name: "Documents",
        mixins: [SharedMixin],
        props: {
            el: String,
            zeevUrl: String,
            token: String,
            instanceId: String,
            taskId: String,
            signPlatformUid: String,
            userExecuteId: String,
            userExecuteOriginalId: String,
            envelopeUid: String,
            apiUrl: String,
            envelopeStatusId: String,
            language: String,
            assignmentId: {
                type: String,
                default: ''
            }
        },
        computed: {
            isRequestSignatureDisabled() {
                if (this.signPlatformUid === this.platformUids.D4Sign)
                    return this.signatories.length === 0 || this.signatories.some(signatory => signatory.email === "");
                return false;
            }
        },
        data() {
            return {
                platformUids: PlatformUids,
                showEmailPopup: false,
                signatories: [],
                workflow : 0,
                documents: [],
                selectedDocuments: [],
                isNoDocumentsWarningVisible: false,
                load: {
                    isLoading: true,
                    msg: this.$t("DOCUMENTS.wait"),
                },
                error: {
                    isError: false,
                    msg: "",
                },
                isButtonVisible: false,
                updatedEnvelopeUid: this.envelopeUid,
                urlCallBack: window.location.href,
                divId: this.el.replace("#", ""),
                errorMessage: "",
                draggedIndex: null,
            };
        },
        created() {
            this.setLanguage(this.language);
            this.load.msg = this.$t("DOCUMENTS.wait");
            let self = this;
            EventBus.$on("update-documents-list", () => {
                self.updateDocumentsList();
            });
        },
        mounted() {
            this.showFinishTaskButton(false);
            this.updateDocumentsList();
        },
        methods: {
            updateSelectedDocumentsList: function () {
                this.selectedDocuments = this.documents.filter(function (doc) {
                    return doc.checked == true;
                });

                if (this.selectedDocuments.length > 0)
                    this.isNoDocumentsWarningVisible = false;
            },
            mountDocumentsFromForm: function () {
                let filesArray = [];
                let fields = document.querySelectorAll(".containerFormFileLink");

                for (var i = 0; i < fields.length; i++) {
                    let fieldHasFileAttached =
                        fields[i].querySelectorAll("a").length > 0;

                    if (fieldHasFileAttached) {
                        let origin = "";
                        let fieldName = "";
                        let fileName = "";
                        let fileUrl = "";
                        let previewUrl = "";
                        let date = "-";
                        let user = "-";

                        fieldName = fields[i]?.parentElement
                            ?.querySelector("input")
                            ?.getAttribute("label");

                        origin = fieldName
                            ? `${this.$t("DOCUMENTS.formField")} - ${fieldName}`
                            : this.$t("DOCUMENTS.formField");

                        let urls = fields[i].querySelectorAll("a");

                        if (urls[0]) {
                            //Url preview
                            let urlPreview = urls[0];
                            let nameWithExtension = urlPreview.innerText;
                            fileName = nameWithExtension.substr(
                                0,
                                nameWithExtension.lastIndexOf(".")
                            );
                            previewUrl = urlPreview.getAttribute("href");
                        }

                        if (urls[1]) {
                            //Url download
                            let urlDownload = urls[1];
                            fileUrl = urlDownload.getAttribute("href");
                        }

                        filesArray.push({
                            id: i + fileUrl,
                            name: fileName,
                            user: user,
                            date: date,
                            origin: origin,
                            path: fileUrl,
                            previewPath: previewUrl,
                            checked: false,
                        });
                    }
                }

                return filesArray;
            },
            mountDocumentsFromAttachments: function () {
                let filesArray = [];
                let filesHtml = document.querySelectorAll("#tblFile > tbody > tr ");
                let origin = document.querySelector(
                    "#containerFiles > h5.title-container-files "
                ).innerText;

                for (var i = 0; i < filesHtml.length; i++) {
                    let newFile = filesHtml[i]
                        .querySelector("td.download.d-none.d-lg-table-cell > a")
                        .classList.contains("d-none");
                    let isEnvelopeDocument = filesHtml[i].querySelector(
                        "td.message > div.hub-sign-envelope"
                    ).innerHTML;

                    if (!newFile && !isEnvelopeDocument) {
                        let name = filesHtml[i].querySelector(
                            "td.message > div.message-box.bg-light-primary > div > div.col.no-horizontal-scroll > a"
                        ).innerText;
                        let previewPath = filesHtml[i]
                            .querySelector(
                                "td.message > div.message-box.bg-light-primary > div > div.col.no-horizontal-scroll > a"
                            )
                            .getAttribute("href");
                        let user = filesHtml[i].querySelector(
                            "td.message > div:nth-child(1) > h5"
                        ).innerText;
                        let date = filesHtml[i].querySelector(
                            "td.message > div.text-right.pt-1 > span.small"
                        );
                        let path = filesHtml[i]
                            .querySelector("td.download.d-none.d-lg-table-cell > a")
                            .getAttribute("href");

                        let formatedDateSplit = date.innerText.split(" ");
                        let formatedDate = "";

                        if (formatedDateSplit.length > 0) {
                            formatedDate = formatedDateSplit[0];
                        }

                        filesArray.push({
                            id: i + path,
                            name: name,
                            user: user,
                            date: formatedDate,
                            origin: origin,
                            path: path,
                            previewPath: previewPath,
                            checked: false,
                        });
                    }
                }
                return filesArray;
            },
            updateDocumentsList: function () {
                this.load.isLoading = true;

                let documentsForm = this.mountDocumentsFromForm();
                let documentsAttachments = this.mountDocumentsFromAttachments();

                this.documents = documentsForm.concat(documentsAttachments);

                this.load.isLoading = false;
            },
            getFile: async (url) => {
                let response = await fetch(url);
                let contentDisposition = response.headers.get(
                    "Content-Disposition"
                );
                var fileName = contentDisposition
                    .split("filename=")[1]
                    .split(";")[0];
                let file = await response.blob();

                return { name: fileName, file: file };
            },
            prepareAndSendDocuments: function (files) {
                let promises = [];
                let self = this;
                for (var i = 0; i < files.length; i++) {
                    let filePromise = self.preparePromiseFile(files[i]);
                    promises.push(filePromise);
                }

                Promise.all(promises).then((preparedDocuments) => {
                    self.send(preparedDocuments);
                });
            },
            preparePromiseFile: function (file) {
                let filePromise = new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.readAsDataURL(file.file);
                    reader.onload = () =>
                        resolve({
                            name: file.originalName,
                            extension: file.name.substring(
                                file.name.lastIndexOf(".") + 1
                            ),
                            documentBase64: reader.result.split(";base64,")[1],
                        });
                });

                return filePromise;
            },
            getDocumentsToSend: async (self) => {
                let documentsToSend = [];

                for (let i = 0; i < self.selectedDocuments.length; i++) {
                    let document = await self.getFile(
                        self.selectedDocuments[i].path
                    );

                    document.originalName = self.selectedDocuments[i].name;
                    documentsToSend.push(document);
                }

                return documentsToSend;
            },
            sendDocuments: function () {
                this.load.isLoading = true;

                let self = this;

                self.getDocumentsToSend(self).then((documents) => {
                    if (documents.length <= 0) {
                        self.isNoDocumentsWarningVisible = true;
                        this.load.isLoading = false;
                    } else {
                        self.isNoDocumentsWarningVisible = false;
                        self.prepareAndSendDocuments(documents);
                    }
                });
            },
            send: function (documents) {
                let self = this;
                let url = `${self.apiUrl}/api/services/v1/envelopes`;
                let token = btoa(`${self.zeevUrl};${self.token}`);

                let requestBody = {
                    TaskId: parseInt(self.taskId),
                    InstanceId: parseInt(self.instanceId),
                    PlatformUid: self.signPlatformUid,
                    CodUserExecute: parseInt(self.userExecuteId),
                    CodUserExecuteOriginal: self.isNullOrEmptyStringOrZero(
                        self.userExecuteOriginalId
                    )
                        ? null
                        : parseInt(self.userExecuteOriginalId),
                    Documents: documents,
                    Signers: self.signatories,
                    Workflow: self.workflow.toString(),
                    UrlCallback: self.urlCallBack,
                };

                var headers = new Headers();
                headers.append("Authorization", `Bearer ${token}`);
                headers.append("Content-Type", "application/json");
                headers.append("Accept-Language", this.language);

                var requestOptions = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(requestBody),
                };

                fetch(url, requestOptions)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.success) {
                            this.load.isLoading = false;
                            this.updatedEnvelopeUid = response.envelopeId;
                            this.openEditEnvelopeWindow(response.urlViewEnvelope);
                            window.location.reload();
                        } else {
                            this.handleErrors(response);
                        }
                    })
                    .catch((err) => {
                        this.error.msg = err;
                        this.error.isError = true;
                    })
                    .then(() => {
                        this.load.isLoading = false;
                    });
            },
            handleErrors: function (response) {
                var content = JSON.parse(response.content);

                console.warn(
                    response.notifications[0].item3 +
                    ": " +
                    content.errorCode +
                    "  | " +
                    content.message
                );
                if (content.errorCode)
                    switch (content.errorCode) {
                        case "UNABLE_TO_CONVERT_DOCUMENT":
                            window.bsml.toast(
                                this.$t(
                                    "DOCUMENTS.errors.unableToConvertDocument"
                                ) + content.errorCode,
                                "alert-warning"
                            );
                            break;
                        case "USER_LACKS_PERMISSIONS":
                            window.bsml.toast(
                                this.$t("DOCUMENTS.errors.userLackPermissions") +
                                content.errorCode,
                                "alert-warning"
                            );
                            break;

                        default:
                            window.bsml.toast(
                                this.$t("DOCUMENTS.errors.default") +
                                content.errorCode,
                                "alert-warning"
                            );
                            break;
                    }

                if (content.error)
                    switch (content.error) {
                        case "invalid_grant":
                            window.bsml.toast(
                                this.$t("DOCUMENTS.errors.default") + content.error,
                                "alert-warning"
                            );

                            break;

                        default:
                            window.bsml.toast(
                                this.$t("DOCUMENTS.errors.defaultError") + content.error,
                                "alert-warning"
                            );
                            break;
                    }
            },
            getInterfaceUrl: function () {
                this.error.isError = false;
                this.load.isLoading = true;

                let token = btoa(`${this.zeevUrl};${this.token}`);
                let url = `${this.apiUrl}/api/services/v1/envelopes/view/${this.signPlatformUid}/${this.updatedEnvelopeUid}?urlCallBack=${this.urlCallBack}`;

                var headers = new Headers();
                headers.append("Authorization", `Bearer ${token}`);
                headers.append("Accept-Language", this.language);

                var requestOptions = {
                    method: "GET",
                    headers: headers,
                };

                fetch(url, requestOptions)
                    .then((response) => response.json())
                    .then((response) => {
                        this.load.isLoading = false;

                        this.openEditEnvelopeWindow(response.urlViewEnvelope);
                    })
                    .catch((err) => {
                        this.error.msg = err;
                        this.error.isError = true;
                    })
                    .then(() => {
                        this.load.isLoading = false;
                    });
            },
            isNullOrEmptyStringOrZero: function (val) {
                return val === null || val === "" || val == 0;
            },
            openEditEnvelopeWindow: function (url) {
                if (this.signPlatformUid !== this.platformUids.D4Sign) {
                    var win = window.open(url, "_blank");

                    if (win) {
                        win.focus();
                    } else {
                        this.error.isError = true;
                        this.error.msg = this.$t("DOCUMENTS.popupWarning");
                    }
                } 
            },
            updateEnvelopeView: function () {
                this.error.isError = false;
                this.load.isLoading = true;

                let url = `${this.apiUrl}/api/internal/v1/envelope/${this.updatedEnvelopeUid}/status`;
                let token = btoa(`${this.zeevUrl};${this.token}`);

                var headers = new Headers();

                headers.append("Authorization", `Bearer ${token}`);
                headers.append("Accept-Language", this.language);

                var requestOptions = {
                    method: "GET",
                    headers: headers,
                };

                fetch(url, requestOptions)
                    .then((response) => response.json())
                    .then((envelope) => {
                        EventBus.$emit(
                            "update-envelope-view",
                            this.el,
                            this.zeevUrl,
                            this.token,
                            this.instanceId,
                            this.taskId,
                            this.signPlatformUid,
                            this.userExecuteId,
                            this.userExecuteOriginalId,
                            this.updatedEnvelopeUid,
                            this.apiUrl,
                            envelope.statusId.toString(),
                            this.language
                        );
                    })
                    .catch((err) => {
                        this.error.isError = true;
                        this.error.msg = err;
                    })
                    .then(() => {
                        this.load.isLoading = false;
                    });
            },
            isValidEmail(email) {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailPattern.test(email);
            },
            saveEmails() {
                this.errorMessage = "";
                let hasInvalidEmail = false;
                if (this.signatories.length === 0) {
                    this.errorMessage = this.$t("REGISTERSIGNERS.noSignatories");
                    return;
                }

                this.signatories = this.signatories.filter((signatory, index) => {
                    if (!this.isValidEmail(signatory.email)) {
                        this.$set(this.signatories[index], 'hasError', true);
                        hasInvalidEmail = true;
                    } else {
                        this.$set(this.signatories[index], 'hasError', false);
                    }

                    return true; 
                });

                if (hasInvalidEmail) {
                    this.errorMessage = this.$t("REGISTERSIGNERS.invalidEmail");
                } else {
                    this.showEmailPopup = false;
                }
            },
            addEmailRow() {
                this.errorMessage = "";
                this.signatories.push({
                    email: '',
                    act: '1',
                    certificadoicpbr: '0',
                    docSelfie: '0'
                });
            },
            removeEmail(index) {
                this.signatories.splice(index, 1);
            },
            cancelEmail() {
                this.errorMessage = "";
                this.signatories = [];
                this.showEmailPopup = false;
                this.workflow = 0;
            },
            dragStart(index) {
                this.draggedIndex = index;
            },
            drop(index) {
                const draggedItem = this.signatories[this.draggedIndex];
                this.signatories.splice(this.draggedIndex, 1);
                this.signatories.splice(index, 0, draggedItem);
                this.draggedIndex = null;
            },
            dragEnd() {
                this.draggedIndex = null;
            }
        },
    };
</script>

<style scoped>
    .button-update {
        display: inline-block;
        padding-top: 0px;
    }

    h5 {
        display: inline-block;
        margin-right: 10px;
    }

    .popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .popup-content {
        background-color: #fff;
        padding: 20px;
        border-radius: 5px;
        width: 1100px !important;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }

    .text-right {
        text-align: right;
        margin-top: 20px;
    }

    .btn-icon-trash {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
    }

    .icon-trash {
        width: 12px;
        height: 12px;
        position: relative;
    }

        .icon-trash::before,
        .icon-trash::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 2px;
            background-color: red;
            top: 50%;
            left: 0;
            transform: translateY(-50%) rotate(45deg);
        }

        .icon-trash::after {
            transform: translateY(-50%) rotate(-45deg);
        }

    .btn-icon-trash:hover .icon-trash::before,
    .btn-icon-trash:hover .icon-trash::after {
        background-color: darkred;
    }

    .popup-content {
        position: relative;
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
        width: 400px;
        margin: 0 auto;
    }

    .btn-icon-add {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
    }

    .icon-plus {
        font-weight: bold;
        color: #28a745;
    }

    .btn-icon-add:hover .icon-plus {
        color: #218838;
    }

    .is-invalid {
        border-color: red;
    }
</style>